import React from "react";
import "../styles.css";
import "bootstrap/dist/css/bootstrap.min.css";

function Header() {
  return (
    <div className="Header">
      <nav className="navbar fixed-top navbar-dark bg-dark">
        <a className="navbar-brand" href="...">
          NAHC
        </a>
        <span className="navbar-text">Caring for our Natural Hair</span>
      </nav>
    </div>
  );
}

export default Header;
